import { Component, EventEmitter, Input, Output } from '@angular/core';
import { SewIcon } from '@sew/ui-components-angular/standalone';

@Component({
    selector: 'blog-form-tablet',
    templateUrl: './form-tablet.component.html',
    styleUrls: ['./form-tablet.component.scss'],
    imports: [SewIcon],
})
export class FormTabletComponent {
    @Output() public subscribeClicked = new EventEmitter();

    @Input() public txtSubscribe = '';

    public onSubscribeClicked(): void {
        this.subscribeClicked.emit();
    }
}
